import { Caption, H4, Paragraph } from '@collab/atoms';
import { Tab, TabContainer } from '@collab/molecules';

import { ColorBlockStandalone } from 'atoms/ColorBlock';

const ColorUsage: React.FC = () => (
  <TabContainer headerBg="primary">
    <Tab title="Light UI" paddedContent>
      <H4> Background / primary </H4>
      <Paragraph>Use as the primary background colour for light UI.</Paragraph>
      <ColorBlockStandalone color="background.primary" hasBorder />
      <H4> Background / secondary </H4>
      <Paragraph>
        Use as the secondary background colour for light UI.
      </Paragraph>
      <ColorBlockStandalone color="background.secondary" hasBorder />
      <H4> Foreground / primary </H4>
      <Paragraph>
        Use for styling primary content such as text and icons. May sit on top
        of any light UI background colours.
      </Paragraph>
      <ColorBlockStandalone color="foreground.primary" />
      <H4> Foreground / secondary </H4>
      <Paragraph>
        Use for styling secondary content such as text and icons. May sit on top
        of any light UI background colours.
      </Paragraph>
      <ColorBlockStandalone color="foreground.secondary" />
      <H4> Blue / primary *</H4>
      <Paragraph>
        Key brand colour. Use to style primary UI buttons (call-to-actions),
        which contain white text labels. Only use as a primary button fill
        colour.
      </Paragraph>
      <ColorBlockStandalone color="brand.primary" />
      <Caption>* Used in both themes currently.</Caption>
      <H4> Blue / accent </H4>
      <Paragraph>
        Use the accent colour to style standalone buttons/links and selected UI
        states within light UI. May sit on top of any light UI background
        colour.
      </Paragraph>
      <ColorBlockStandalone color="foreground.action" />
      <H4> Alerts </H4>
      <Paragraph>
        Use for highlighting errors, invalid data and destructive actions. May
        sit on top of any light UI background colour.
      </Paragraph>
      <ColorBlockStandalone color="ornament.alert" />
      <H4> Ornamental / border </H4>
      <Paragraph>
        Use to visually group or separate UI elements within light UI.
      </Paragraph>
      <ColorBlockStandalone color="ornament.border" />
      <H4> Ornamental / divider </H4>
      <Paragraph>
        Use to visually group or separate UI elements within light UI.
      </Paragraph>
      <ColorBlockStandalone color="ornament.divider" />
    </Tab>

    <Tab title="Dark UI" paddedContent>
      <H4> Background / primary </H4>
      <Paragraph>Use as the primary background colour for dark UI.</Paragraph>
      <ColorBlockStandalone
        themeVariant="dark"
        color="dark.background.primary"
      />
      <H4> Background / secondary </H4>
      <Paragraph>Use as the secondary background colour for dark UI.</Paragraph>
      <ColorBlockStandalone
        themeVariant="dark"
        color="dark.background.secondary"
      />
      <H4> Foreground / primary </H4>
      <Paragraph>
        Use for styling primary content such as text and icons. May sit on top
        of any dark UI background colours.
      </Paragraph>
      <ColorBlockStandalone
        themeVariant="dark"
        color="foreground.primary"
        hasBorder
      />
      <H4> Foreground / secondary </H4>
      <Paragraph>
        Use for styling secondary content such as text and icons. May sit on top
        of any dark UI background colours.
      </Paragraph>
      <ColorBlockStandalone themeVariant="dark" color="foreground.secondary" />
      <H4> Blue / primary *</H4>
      <Paragraph>
        Key brand colour. Use to style primary UI buttons (Call-to-actions),
        which contain white text labels. Only use as a primary button fill
        colour.
      </Paragraph>
      <ColorBlockStandalone themeVariant="dark" color="brand.primary" />
      <Caption>* Used in both themes currently.</Caption>
      <H4> Blue / accent </H4>
      <Paragraph>
        Use the accent colour to style standalone buttons/links and selected UI
        states within dark UI. May sit on top of any dark UI background colour.
      </Paragraph>
      <ColorBlockStandalone
        themeVariant="dark"
        color="dark.foreground.action"
      />
      <H4> Alerts </H4>
      <Paragraph>
        Use for highlighting errors, invalid data and destructive actions. May
        sit on top of any dark UI background colour.
      </Paragraph>
      <ColorBlockStandalone themeVariant="dark" color="ornament.alert" />
      <H4> Ornamental / border </H4>
      <Paragraph>
        Use to visually group or separate UI elements within dark UI.
      </Paragraph>
      <ColorBlockStandalone themeVariant="dark" color="dark.ornament.border" />
      <H4> Ornamental / divider </H4>
      <Paragraph>
        Use to visually group or separate UI elements within dark UI.
      </Paragraph>
      <ColorBlockStandalone themeVariant="dark" color="ornament.divider" />
    </Tab>
  </TabContainer>
);

export default ColorUsage;
